import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "./common/PageHeader";
import Button from "./common/Button";

const TemplateListHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
      <PageHeader
        title="Template List"
        subtitle="Manage your WhatsApp message templates"
        className="mb-0"
        action={
          <Button
            variant="primary"
            onClick={() => navigate("/template/create")}
            icon={
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4v16m8-8H4"
                />
              </svg>
            }
          >
            Create Template
          </Button>
        }
      />
    </div>
  );
};

export default TemplateListHeader;
